import { createContext } from "react";
const LoadingContext = createContext({
    isLoading: false,
    setIsLoading: (value) => { },
});
export default LoadingContext;
